import React from "react";
import styled from "styled-components";

const breakpoints = {
  tablet: 768,
  phone:  480,
};

const TAB_HOVER_COLOR = "#F7941D";

const TabsContainer = styled.ul`
  display: flex;
  justify-content: center;
  list-style-type: none;
  border-bottom: 2px solid #ccc;

  li {
    margin-right: 15px;
    margin-bottom: 30px;
  }

  a {
    text-decoration: none;
    padding: 10px 40px;
    border: 1px solid transparent;
    border-radius: 5px;
    background-color: ${(props) => props.colors.cardBackground};
    color: ${(props) => props.colors.buttonBackground};
    transition: all 0.3s;
    font-weight: 600;

    &.selected {
      background-color: ${(props) => props.colors.buttonBackground};
      color: white;
      border-color: ${(props) => props.colors.buttonBackground};
    }

    &:not(.selected) {
      background-color: ${(props) => props.colors.titleText};
      color: ${(props) => props.colors.buttonBackground};
    }

    &:hover {
      background-color: ${TAB_HOVER_COLOR};
      border-color: ${TAB_HOVER_COLOR};
      color: white;
    }
  }
    @media (max-width: ${breakpoints.phone}px) {
    width: 450px;
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    justify-content: flex-start;
    flex-wrap: nowrap;
    padding: 10px;
    margin-bottom: 0;
     a {
      padding: 8px 12px;
      font-size: 0.9rem;
    }
  }
`;

const AdminTabs = ({ colors, selectedTab, handleTabClick }) => {
  const tabs = [
    "Administrators",
    "Submit Quotes",
    "Quotes",
  ];

  return (
    <TabsContainer colors={colors}>
      {tabs.map((tab) => (
        <li key={tab}>
          <a
            href="#"
            className={selectedTab === tab ? "selected" : ""}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </a>
        </li>
      ))}
    </TabsContainer>
  );
};

export default AdminTabs;
